import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import Home from './screens/Home';
import Projectstatus from './screens/Projectstatus';
import Waitingroom from './screens/Waitingroom';
import RegistOTP from './screens/RegistOTP';
import CreateProject from './screens/CreateProject';
import CronJobDashboard from './screens/CronJobDashboard';
import SSLMonitoring from './screens/SSLMonitoring';
import PrometheusMonitoring from './screens/PrometheusMonitoring';
import { useMediaQuery } from 'react-responsive';

export default function App() {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/registOTP" element={<RegistOTP />} />
        <Route 
          path="/projectstatus" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="프로젝트 상태">
                    <Projectstatus />
                  </AppLayout>
                ) : (
                  <Projectstatus />
                )
              } 
            />
          } 
        />
        <Route 
          path="/waitingroom" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="대기실">
                    <Waitingroom />
                  </AppLayout>
                ) : (
                  <Waitingroom />
                )
              } 
            />
          } 
        />
        <Route 
          path="/create-project" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="프로젝트 생성">
                    <CreateProject />
                  </AppLayout>
                ) : (
                  <CreateProject />
                )
              } 
            />
          } 
        />
        <Route 
          path="/cron-dashboard" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="크론잡 관리">
                    <CronJobDashboard />
                  </AppLayout>
                ) : (
                  <CronJobDashboard />
                )
              } 
            />
          } 
        />
        <Route 
          path="/ssl-monitoring" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="SSL 모니터링">
                    <SSLMonitoring />
                  </AppLayout>
                ) : (
                  <SSLMonitoring />
                )
              } 
            />
          } 
        />
        <Route 
          path="/prometheus-monitoring" 
          element={
            <ProtectedRoute 
              element={
                isDesktop ? (
                  <AppLayout title="시스템 모니터링">
                    <PrometheusMonitoring />
                  </AppLayout>
                ) : (
                  <PrometheusMonitoring />
                )
              } 
            />
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}